// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

import { Progress } from '../../types/Model';

export interface OnlineCourseChaptersProgressRequestPayload {
  id: number;
  progress: Progress;
}
export interface OnlineCourseChaptersProgressSuccessPayload {
  id: number;
  progress: Progress[];
  revisedTime: Date;
}

export interface OnlineCourseChaptersProgressFailPayload {
  error: Error;
}

export const postOnlineCourseChaptersProgressActions = createAsyncAction(
  'elearning/POST_ONLINE_COURSE_CHAPTERS_PROGRESS',
  'elearning/POST_ONLINE_COURSE_CHAPTERS_PROGRESS_SUCCESS',
  'elearning/POST_ONLINE_COURSE_CHAPTERS_PROGRESS_FAIL'
)<
  OnlineCourseChaptersProgressRequestPayload,
  OnlineCourseChaptersProgressSuccessPayload,
  OnlineCourseChaptersProgressFailPayload
>();
